import { decryptFile } from "../dataEncryption";
import { concatLogsAndVars, createEmptyLogsAndVars, recordVariable, ReportingError } from "../diagnostics/clientErrors";
import { sendMessageWithMpcWallet } from "./dwcommonutils";
import { jwtMessageAsGetReturnsBinary } from "./jwtcomm";
const apiVersion = process.env.API_VERSION || "1.0";
export async function getMetadataJwt(provider, authToken, storagePath) {
    //console.log(provider, authToken, storagePath);
    const logsAndVars = createEmptyLogsAndVars("dwmetadata:getMetadataJwt");
    if (storagePath === undefined) {
        throw new ReportingError("missing storagePath", logsAndVars);
    }
    //const encryptedPath = await encryptAsciiStringToHexString(storagePath);
    const sendObject = {
        path: storagePath,
    };
    const encryptedMetadataFile = await jwtMessageAsGetReturnsBinary("get", `/api/${apiVersion}/graph/metadata`, authToken, sendObject);
    const decryptedMetadataFile = await decryptFile(provider, encryptedMetadataFile);
    const responseText = await new Response(decryptedMetadataFile).text();
    return JSON.parse(responseText);
}
export async function getMetadata(storageProps, storagePath) {
    const portalClientId = storageProps.portalClientId;
    const clientSessionToken = storageProps.clientSessionToken;
    const userShare = storageProps.ed25519UserShare;
    return await getMetadataWithParams(portalClientId, clientSessionToken, userShare, storagePath);
}
export async function getMetadataWithParams(portalClientId, clientSessionToken, userShare, storagePath) {
    let logsAndVars = createEmptyLogsAndVars("dwmetadata:getMetadata");
    recordVariable(logsAndVars, "portalClientId (param)", portalClientId);
    recordVariable(logsAndVars, "clientSessionToken (param)", clientSessionToken);
    if (portalClientId === undefined) {
        throw new ReportingError("missing portalClientId", logsAndVars);
    }
    if (clientSessionToken === undefined) {
        throw new ReportingError("missing clientSessionToken", logsAndVars);
    }
    if (userShare === undefined) {
        throw new ReportingError("missing userShare", logsAndVars);
    }
    if (storagePath === undefined) {
        throw new ReportingError("missing storagePath", logsAndVars);
    }
    const sendObject = {
        method: "get",
        endpoint: `/api/${apiVersion}/graph/metadata`,
        clientId: portalClientId,
        path: storagePath,
    };
    recordVariable(logsAndVars, "sendObject", sendObject);
    try {
        return await sendMessageWithMpcWallet(clientSessionToken, userShare, sendObject, undefined, undefined, process.env.DWINITY_BACKEND ?? process.env.DWINITY_BACKEND ?? "https://api.dev.dwinity.com");
    }
    catch (error) {
        if (error instanceof ReportingError) {
            logsAndVars = concatLogsAndVars(logsAndVars, error.logsAndVars);
        }
        throw new ReportingError(error, logsAndVars);
    }
}
